import { motion } from "framer-motion";
import { ArrowDownRight, ShieldCheck } from "lucide-react";
import { COMPANY, IMAGES } from "@/data/site";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.3 + i * 0.12 } }),
};

const Line = ({ children, i }) => (
  <span className="reveal-mask">
    <motion.span variants={line} custom={i} initial="hidden" animate="show" className="block">
      {children}
    </motion.span>
  </span>
);

export const Hero = ({ onQuote }) => {
  return (
    <section id="top" className="relative min-h-screen flex items-end overflow-hidden">
      <motion.div
        initial={{ scale: 1.12 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0"
      >
        <img src={IMAGES.hero} alt="Toiture terrasse architecturale" className="w-full h-full object-cover img-arch" />
        <div className="absolute inset-0 bg-gradient-to-t from-mh-bg via-mh-bg/70 to-mh-bg/40" />
      </motion.div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-10 pb-16 lg:pb-24 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold">Étanchéité • Isolation • PACA</span>
        </motion.div>

        <h1 className="font-display font-black uppercase tracking-tighter leading-[0.85] text-white text-5xl sm:text-7xl lg:text-8xl">
          <Line i={0}>L'étanchéité</Line>
          <Line i={1}>qui protège vos</Line>
          <Line i={2}><span className="text-mh-orange">toitures & terrasses</span></Line>
        </h1>

        <div className="mt-10 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.7 }}
            className="max-w-md text-mh-slate text-base leading-relaxed"
          >
            MH Étanchéité intervient sur toitures terrasses, balcons, murs enterrés et
            isolation thermique dans le Var, les Alpes-Maritimes et toute la région PACA.
            Travaux garantis décennale.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.15, duration: 0.7 }}
            className="flex flex-wrap items-center gap-4"
          >
            <button
              onClick={onQuote}
              className="group flex items-center gap-3 bg-mh-orange hover:bg-mh-orangeHover text-white font-semibold px-7 py-4 transition-colors"
              data-testid="hero-quote-btn"
            >
              Demander un devis gratuit
              <ArrowDownRight size={18} className="group-hover:rotate-45 transition-transform" />
            </button>
            <div className="flex items-center gap-2 text-sm text-white/90 border border-mh-line px-5 py-4">
              <ShieldCheck size={18} className="text-mh-orange" /> Garantie décennale
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
